import { getDataWithParams } from "app/helpers/apiHelperV3";
import { urls } from "./urls";

const API_SPORTS_SELECTION = urls.data.API_SPORTS_SELECTION();

/**
 * fetch sports list
 */
export const fetchSportsSelectionList = (payload: any): any => {
  const params = {
    after: payload.after,
    before: payload.before,
  };
  return getDataWithParams(API_SPORTS_SELECTION, params);
};
